// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1kRF3","info":"PatientInfo_info__323g6"};